import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AlertComponent, ModalComponent, InfoGroupComponent } from '@tecalisdev/infinity';
import { formatDate, notAvailableLabel } from '../../../core/utils/utils';
import { LoadingService } from '../../../shared/services/loading.service';
import { IUserActivityDetail, IUserActivityListItem } from '../../models/user-activity.models';
import { UserActivityService } from '../../services/user-activity.service';

@Component({
	selector: 'app-activity-detail',
	imports: [TranslatePipe, ModalComponent, AlertComponent, InfoGroupComponent],
	templateUrl: './activity-detail.component.html',
	styleUrl: './activity-detail.component.scss',
})
export class ActivityDetailModalComponent implements OnChanges {
	private activityService = inject(UserActivityService);
	private loading = inject(LoadingService);
	private trans = inject(TranslateService);

	@Input() uuid?: string | null;
	@Input() initialData?: IUserActivityListItem | null;
	@Output() closeEvent = new EventEmitter<void>();

	public detail?: IUserActivityDetail | null = null;
	public alertError = '';

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['uuid']?.currentValue) {
			this.getDetail();
		}
	}

	public closeModal(): void {
		this.closeEvent.emit();
	}

	public get userLabel(): string {
		return this.detail?.user?.name || this.detail?.user?.email || this.detail?.user?.uuid || notAvailableLabel(this.trans);
	}

	public get formattedOccurredAt(): string {
		if (this.detail?.occurred_at) {
			return formatDate(this.detail.occurred_at);
		}

		return this.initialData?.occurred_at || notAvailableLabel(this.trans);
	}

	private getDetail(): void {
		if (!this.uuid) return;

		this.alertError = '';
		this.loading.show(this.trans.instant('LOADING.GET_ACTIVITY'));
		const companyUuid = this.initialData?.company?.uuid;
		const params = companyUuid ? { company_uuid: companyUuid } : undefined;
		this.activityService.get(this.uuid, params).subscribe({
			next: (response) => {
				this.detail = response;
			},
			error: (_error: HttpErrorResponse) => {
				this.alertError = this.trans.instant('ERRORS.GENERIC_DESCRIPTION');
			},
			complete: () => {
				this.loading.hide();
			},
		});
	}
}
